import { closeBanner } from "../helper/axios";
import DiscountBanner from '../../shared/components/discount-banner';

const EventBanner = ({ bannerData }) => {
    return (
        <DiscountBanner
            bannerData={bannerData}
            utmMedium="dashboard-discount-banner"
            onClose={closeBanner}
        />
    );
};

export default EventBanner;
